import { MENU_ITEM, MENU_SECTION_NAME } from './bulkEdit';
import { EBAY, ETSY, FAIRE, SHOPIFY } from './channels';

export const FIELD_NAME = {
  [EBAY]: {
    category_id: MENU_ITEM.ITEM_CATEGORY,
    condition_description: MENU_ITEM.CONDITION,
    condition_id: MENU_ITEM.CONDITION,
    country: MENU_ITEM.ITEM_LOCATION,
    description: MENU_ITEM.DESCRIPTION,
    item_specifics: MENU_SECTION_NAME[EBAY][MENU_ITEM.TAXONOMY],
    location: MENU_ITEM.ITEM_LOCATION,
    payment_policy_id: MENU_ITEM.PAYMENT_POLICY,
    photos: MENU_ITEM.PHOTOS,
    postal_code: MENU_ITEM.ITEM_LOCATION,
    price: MENU_ITEM.PRICE,
    product_listing_details: MENU_SECTION_NAME[EBAY][MENU_ITEM.TAXONOMY],
    quantity: MENU_ITEM.QUANTITY,
    return_policy_id: MENU_ITEM.RETURN_POLICY,
    shipping_package_depth: MENU_ITEM.ITEM_SIZE,
    shipping_package_length: MENU_ITEM.ITEM_SIZE,
    shipping_package_major_weight: MENU_ITEM.ITEM_WEIGHT,
    shipping_package_minor_weight: MENU_ITEM.ITEM_WEIGHT,
    shipping_package_width: MENU_ITEM.ITEM_SIZE,
    shipping_policy_id: MENU_ITEM.SHIPPING_POLICY,
    sku: MENU_ITEM.SKU,
    title: MENU_ITEM.TITLE,
    variationsInventory: MENU_ITEM.VARIATIONS,
    videos: MENU_ITEM.VIDEOS,
  },
  [ETSY]: {
    attributes: MENU_SECTION_NAME[ETSY][MENU_ITEM.TAXONOMY],
    description: MENU_ITEM.DESCRIPTION,
    files: MENU_ITEM.FILES,
    isPersonalizable: MENU_ITEM.PERSONALIZATION,
    is_supply: MENU_ITEM.ABOUT,
    itemHeight: MENU_ITEM.ITEM_SIZE,
    itemLength: MENU_ITEM.ITEM_SIZE,
    itemWeight: MENU_ITEM.ITEM_WEIGHT,
    itemWidth: MENU_ITEM.ITEM_SIZE,
    materials: MENU_ITEM.MATERIALS,
    personalizationCharCountMax: MENU_ITEM.PERSONALIZATION,
    personalizationInstructions: MENU_ITEM.PERSONALIZATION,
    personalizationIsRequired: MENU_ITEM.PERSONALIZATION,
    photos: MENU_ITEM.PHOTOS,
    priceInventory: MENU_ITEM.PRICE,
    productionPartners: MENU_ITEM.PRODUCTION_PARTNER,
    quantityInventory: MENU_ITEM.QUANTITY,
    return_policy_id: MENU_ITEM.RETURN_POLICY,
    section: MENU_ITEM.SECTION,
    shipping_template_id: MENU_ITEM.SHIPPING_PROFILE,
    skuInventory: MENU_ITEM.SKU,
    tags: MENU_ITEM.TAGS,
    taxonomy: MENU_ITEM.CATEGORY,
    title: MENU_ITEM.TITLE,
    variationsInventory: MENU_ITEM.VARIATIONS,
    videos: MENU_ITEM.VIDEOS,
    when_made: MENU_ITEM.ABOUT,
    who_made: MENU_ITEM.ABOUT,
  },
  [SHOPIFY]: {
    barcodeInventory: MENU_ITEM.BARCODE,
    body_html: MENU_ITEM.DESCRIPTION,
    category: MENU_ITEM.CATEGORY,
    collection_ids: MENU_ITEM.COLLECTIONS,
    comapreAtPriceInventory: MENU_ITEM.CAP,
    countryCode: MENU_ITEM.COUNTRY_CODE,
    costInventory: MENU_ITEM.CPI,
    hsCode: MENU_ITEM.HS_CODE,
    inventoryPolicy: MENU_ITEM.QUANTITY,
    inventoryManagement: MENU_ITEM.QUANTITY,
    photos: MENU_ITEM.PHOTOS,
    physical: 'Physical',
    priceInventory: MENU_ITEM.PRICE,
    product_type: MENU_ITEM.PRODUCT_TYPE,
    quantityInventory: MENU_ITEM.QUANTITY,
    seoDescription: MENU_ITEM.META_DESCRIPTION,
    seoTitle: MENU_ITEM.PAGE_TITLE,
    skuInventory: MENU_ITEM.SKU,
    tags: MENU_ITEM.TAGS,
    title: MENU_ITEM.TITLE,
    variationsInventory: MENU_ITEM.VARIATIONS,
    variations: MENU_ITEM.VARIATIONS,
    vendor: MENU_ITEM.VENDOR,
    videos: MENU_ITEM.VIDEOS,
    weight: MENU_ITEM.WEIGHT,
  },
  [FAIRE]: {
    title: MENU_ITEM.TITLE,
    description: MENU_ITEM.DESCRIPTION,
    minimum_order_quantity: MENU_ITEM.QUANTITY,
    per_style_minimum_order_quantity: MENU_ITEM.QUANTITY,
    quantity: MENU_ITEM.QUANTITY,
    unit_multiplier: 'Unit Multiplier',
    allow_sales_when_out_of_stock: 'Allow sales when out of stock',
    category_id: MENU_ITEM.CATEGORY,
    preorderable: 'Preorderable',
    photos: MENU_ITEM.PHOTOS,
    price: MENU_ITEM.PRICE,
    prices: MENU_ITEM.PRICE,
    price_variant: MENU_ITEM.PRICE,
  },
};
